import React,{Component} from 'react'
import moment from 'moment'; 
import 'moment/locale/zh-cn'; 
import {ConfigProvider,DatePicker,Button,Table} from 'antd';
import zhCN from 'antd/es/locale/zh_CN'; 
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

export default class checkFrom extends Component{
    constructor(){
        super();
        this.state={
            top: 'none',
            bottom: 'bottomRight',
            local:zhCN,
            data:[],
            timeStart:'',
            timeEnd:'',
            lengths:0,
        }
    }
    onChangeStart(date,time){
        this.setState({
            timeStart:time
        })
    }
    onChangeEnd(date,time){
        this.setState({
            timeEnd:time
        })
    }
    getSearch(){
        let params = {
            startDate:this.state.timeStart,
            endDate:this.state.timeEnd,
        }
        React.$http.getTruePaperCheck(params).then((res)=>{
            if(res&&res.success){
                this.setState({
                    data:res.list,
                    lengths:res.list.length
                })
            }
        })
    }
    componentDidMount(){
        React.$http.getTruePaperCheck().then((res)=>{
            if(res&&res.success){
                res.list.forEach((v,key)=>{
                    v.key = key+1
                })
                this.setState({
                    data:res.list,
                    lengths:res.list.length
                })
            }
        })
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }
    render(){
        const {
            data,local,lengths
        } = this.state;
        const columns = [
            {
                title: '序号',
                dataIndex: 'key',
            },
            {
                title: '订单编号',
                dataIndex: 'order_no',
            },
            {
                title: '用户名',
                dataIndex: 'realname',
            },
            {
                title: '作者',
                dataIndex: 'author',
            },
            {
                title: '手机号',
                dataIndex: 'phone',
            },
            {
                title: '论文标题',
                dataIndex: 'title',
            },
            {
                title: '支付金额',
                dataIndex: 'userCost',
            },
            {
                title: '订单状态',
                dataIndex: 'status_name',
                // render: text => <span>
                //     {text===4?'已完成':''}
                //     {text===5?'已完成':''}
                //     {text>6?'已关闭':''}
                // </span>,
            },
            {
                title: '下单时间',
                dataIndex: 'addtime',
            },
            {
                title: '下单IP',
                dataIndex: 'ip',
            },
            {
                title: '下单省份',
                dataIndex: 'province',
            },
            {
                title: 'IP对应机构',
                dataIndex: 'groupName',
            },
        ];
        return(
            <div className="wrap">
                <div className="title">论文查重流量统计</div>
                <div className="nav">
                    下单时间：
                    <ConfigProvider locale={local}>
                        <DatePicker onChange={this.onChangeStart.bind(this)} />
                    </ConfigProvider>
                    <span className="marbtn">-</span>
                    <ConfigProvider locale={local}>
                        <DatePicker onChange={this.onChangeEnd.bind(this)} />
                    </ConfigProvider>
                    <Button className="marbtn" onClick={this.getSearch.bind(this)}>查询</Button>
                </div>
                <div className="space">
                    <div className="num">共<span className="number">{lengths}</span>个订单</div>
                    <div className="btn">
                        <Button type="danger" onClick={()=>alert('功能待完善')}>批量导出</Button>
                    </div>
                    <div className="clear"></div>
                </div>
                <div className="table">
                    <ConfigProvider locale={local}>
                        <Table columns={columns} dataSource={data} rowKey={record=>record.key}/>
                    </ConfigProvider>
                </div>
            </div>
        )
    }
}
